/* Eight Theme. Built from eight-theme-tools/src; edit there. */
/* ==========================================================================
   Eight Theme: core. Plain web components, no libraries.
   ========================================================================== */
(function () {
  'use strict';
  var eight = window.eight = window.eight || {};

  /* ---------- helpers ---------- */
  eight.q = function (sel, root) { return (root || document).querySelector(sel); };
  eight.qa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  eight.debounce = function (fn, ms) {
    var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); };
  };
  eight.isPhone = function () { return window.matchMedia('(max-width: 768px)').matches; };
  eight.reducedMotion = function () { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; };

  eight.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || (eight.settings && eight.settings.moneyFormat) || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, prec, thou, dec) {
      thou = thou === undefined ? ',' : thou; dec = dec === undefined ? '.' : dec;
      if (isNaN(n) || n == null) return 0;
      n = (n / 100.0).toFixed(prec);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou);
      return dollars + (parts[1] ? dec + parts[1] : '');
    }
    var m = format.match(placeholder); var v = '';
    switch (m ? m[1] : 'amount') {
      case 'amount': v = fmt(cents, 2); break;
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = fmt(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(placeholder, v);
  };

  /* Section Rendering API: fetch a section's fresh HTML for the current URL */
  eight.fetchSection = function (id, url) {
    var u = new URL(url || window.location.href, window.location.origin);
    u.searchParams.set('section_id', id);
    return fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) { return r.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
  };

  /* ---------- overlay + scroll lock shared by drawers and modals ---------- */
  var overlay;
  var openCount = 0;
  function getOverlay() {
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'eight-overlay';
      overlay.addEventListener('click', function () { eight.closeAll(); });
      document.body.appendChild(overlay);
      void overlay.offsetWidth; /* first open fades in too */
    }
    return overlay;
  }
  eight.lock = function (fadeIn) {
    openCount++;
    var ov = getOverlay();
    ov.style.transitionDuration = fadeIn || '';
    ov.classList.add('is-open');
    document.documentElement.classList.add('eight-lock');
  };
  eight.unlock = function () {
    openCount = Math.max(0, openCount - 1);
    if (!openCount) {
      getOverlay().style.transitionDuration = '';
      getOverlay().classList.remove('is-open');
      document.documentElement.classList.remove('eight-lock');
    }
  };
  eight.closers = [];
  eight.closeAll = function () { eight.closers.slice().forEach(function (fn) { fn(); }); };
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') eight.closeAll(); });

  function trapFocus(container, e) {
    var f = eight.qa('a[href],button:not([disabled]),input:not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])', container)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- <eight-drawer> ---------- */
  class EightDrawer extends HTMLElement {
    connectedCallback() {
      var self = this;
      this._close = this.close.bind(this);
      this.addEventListener('click', function (e) { if (e.target.closest('[data-close-drawer]')) self.close(); });
      this.addEventListener('keydown', function (e) { if (e.key === 'Tab' && self.isOpen) trapFocus(self, e); });
    }
    open(opener) {
      if (this.isOpen) return;
      eight.closeAll();
      this.isOpen = true;
      clearTimeout(this._closing); this.classList.remove('is-closing');
      this._opener = opener || document.activeElement;
      this.hidden = false;
      var self = this;
      requestAnimationFrame(function () { self.classList.add('drawer--is-open'); });
      eight.lock();
      eight.closers.push(this._close);
      if (this._opener && this._opener.setAttribute) this._opener.setAttribute('aria-expanded', 'true');
      setTimeout(function () { var f = self.querySelector('[data-close-drawer]'); if (f) f.focus({ preventScroll: true }); }, 50);
      this.dispatchEvent(new CustomEvent('drawer:open', { bubbles: true }));
    }
    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      var me = this;
      this.classList.add('is-closing');
      this.classList.remove('drawer--is-open');
      clearTimeout(this._closing);
      this._closing = setTimeout(function () { me.classList.remove('is-closing'); }, 300);
      eight.unlock();
      eight.closers = eight.closers.filter(function (fn) { return fn !== this._close; }, this);
      if (this._opener && this._opener.setAttribute) { this._opener.setAttribute('aria-expanded', 'false'); this._opener.focus({ preventScroll: true }); }
      this.dispatchEvent(new CustomEvent('drawer:close', { bubbles: true }));
    }
  }
  customElements.define('eight-drawer', EightDrawer);

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-drawer]');
    if (!opener) return;
    var d = document.getElementById(opener.getAttribute('data-open-drawer'));
    if (d && d.open) { e.preventDefault(); d.open(opener); }
  });

  /* ---------- <eight-rotator>: rotates its children one at a time ---------- */
  class EightRotator extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.slides = eight.qa(':scope > *', this);
      // the bar holds its height as a pixel value, as Impulse's slider does (the browser rounds it the same way)
      var hold = function () {
        var h = 0;
        // read through the computed style (six digits), as the slider Impulse uses does
        self.slides.forEach(function (sl) { h = Math.max(h, parseFloat(getComputedStyle(sl).height) || 0); });
        if (h) self.style.height = h + 'px';
      };
      hold();
      window.addEventListener('load', hold);
      window.addEventListener('resize', eight.debounce(function () { self.style.height = ''; hold(); }, 100));
      if (!this.hasAttribute('data-rotate')) return;
      this.index = 0;
      this.interval = parseInt(this.getAttribute('data-interval'), 10) || 5000;
      this.addEventListener('mouseenter', function () { self.paused = true; });
      this.addEventListener('mouseleave', function () { self.paused = false; });
      this.timer = setInterval(function () { if (!self.paused && !document.hidden) self.next(); }, this.interval);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    next() {
      this.slides[this.index].classList.remove('is-selected');
      this.index = (this.index + 1) % this.slides.length;
      this.slides[this.index].classList.add('is-selected');
    }
  }
  customElements.define('eight-rotator', EightRotator);

  /* ---------- <eight-header>: sticky behaviour ---------- */
  class EightHeader extends HTMLElement {
    connectedCallback() {
      if (this.getAttribute('data-sticky') !== 'true') return;
      var self = this;
      this.header = this.querySelector('.site-header');
      this.wrapper = this.closest('.header-sticky-wrapper');
      // the wrapper holds the header's place in whole pixels, so nothing below moves when it sticks
      var hold = function () { if (!self.sticky) { self.wrapper.style.height = ''; self.wrapper.style.height = self.wrapper.offsetHeight + 'px'; } };
      hold();
      window.addEventListener('resize', eight.debounce(hold, 100));
      window.addEventListener('load', hold);
      var onScroll = function () {
        var past = window.scrollY > 250;
        if (past && !self.sticky) {
          self.wrapper.style.height = self.wrapper.offsetHeight + 'px';
          self.classList.add('is-sticky');
          self.sticky = true;
          clearTimeout(self._open);
          self._open = setTimeout(function () { if (self.sticky) self.classList.add('is-opening'); }, 50);
        } else if (!past && self.sticky) {
          clearTimeout(self._open);
          self.classList.remove('is-sticky', 'is-opening');
          self.sticky = false;
          hold();
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }
  customElements.define('eight-header', EightHeader);

  /* Desktop dropdowns: keyboard + click when hover is off */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.site-nav__link--has-dropdown');
    var items = eight.qa('.site-nav__item.is-focused');
    if (!link) { items.forEach(function (i) { i.classList.remove('is-focused'); }); return; }
    var item = link.closest('.site-nav__item');
    if (item.hasAttribute('data-hover') && !('ontouchstart' in window)) return;
    if (!item.classList.contains('is-focused')) {
      e.preventDefault();
      items.forEach(function (i) { i.classList.remove('is-focused'); });
      item.classList.add('is-focused');
      link.setAttribute('aria-expanded', 'true');
    }
  });
  document.addEventListener('focusin', function (e) {
    eight.qa('.site-nav__item.is-focused').forEach(function (i) { if (!i.contains(e.target)) i.classList.remove('is-focused'); });
    var item = e.target.closest && e.target.closest('.site-nav--has-dropdown');
    if (item) item.classList.add('is-focused');
  });

  /* ---------- images fade in once loaded and on screen ---------- */
  (function () {
    function show(img) {
      if (img.classList.contains('is-in')) return;
      if (img.complete) img.classList.add('is-in');
      else {
        var done = function () { img.classList.add('is-in'); };
        img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true });
      }
    }
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); show(en.target); } });
    }, { rootMargin: '0px 0px -120px 0px' }) : null;   // 120px into the screen, as Impulse does
    var rows = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        rows.unobserve(en.target);
        var g = en.target.querySelector(':scope > .grid'); if (g) g.classList.add('is-in');
      });
    }, { rootMargin: '0px 0px -120px 0px' }) : null;
    function watch(root) {
      (root.matches && root.matches('img[data-fade]') ? [root] : []).concat(eight.qa('img[data-fade]:not(.is-in)', root))
        .forEach(function (img) { if (img._fade) return; img._fade = 1; if (io) io.observe(img); else show(img); });
      // watch the row's frame, not the row: the row itself starts a screen width to the right
      eight.qa('.grid-overflow-wrapper > .grid:not(.is-in)', root).forEach(function (g) {
        if (g._fade) return; g._fade = 1; if (rows) rows.observe(g.parentElement); else g.classList.add('is-in');
      });
    }
    eight.observeReveal = function (root) { watch(root || document); };
    watch(document);
    new MutationObserver(function (ms) {
      ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) watch(n); }); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();

  eight.toast = function (msg) {
    var t = document.getElementById('EightToast');
    if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(t._t); t._t = setTimeout(function () { t.hidden = true; }, 3500);
  };
})();

/* ==========================================================================
   Header search panel with predictive results (Shopify's /search/suggest.json)
   ========================================================================== */
(function () {
  'use strict';
  var eight = window.eight;

  /* translations reach the script already HTML-escaped (&quot;); undo that before escaping once */
  function unesc(s) { var t = document.createElement('textarea'); t.innerHTML = String(s); return t.value; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

  class EightSearch extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-search-results]');
      this._close = this.close.bind(this);
      this.addEventListener('click', function (e) { if (e.target.closest('[data-close-search]')) { e.preventDefault(); self.close(); } });
      if (!this.input) return;
      this.input.addEventListener('input', eight.debounce(function () { self.query(self.input.value.trim()); }, 220));
      this.input.addEventListener('focus', function () { if (self.input.value.trim()) self.query(self.input.value.trim()); });
    }
    open() {
      if (this.isOpen) return;
      eight.closeAll();
      this.isOpen = true;
      this.classList.add('is-active');
      document.body.classList.add('predictive-overflow-hidden');
      eight.closers.push(this._close);
      var inp = this.input;
      setTimeout(function () { inp && inp.focus(); }, 30);
    }
    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove('is-active');
      document.body.classList.remove('predictive-overflow-hidden');
      this.results.hidden = true;
      eight.closers = eight.closers.filter(function (fn) { return fn !== this._close; }, this);
    }
    query(term) {
      var self = this;
      if (!term) { this.results.hidden = true; return; }
      if (!eight.settings.predictiveSearch) return;
      if (this.ctrl) this.ctrl.abort();
      this.ctrl = new AbortController();
      var url = (eight.routes.predictiveSearch || '/search/suggest') + '.json?q=' + encodeURIComponent(term) +
        '&resources[type]=query,product,collection,page&resources[limit]=3&resources[limit_scope]=each&resources[options][unavailable_products]=last&section_id=';
      fetch(url.replace('&section_id=', ''), { signal: this.ctrl.signal, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) { self.render(term, (data && data.resources && data.resources.results) || {}); })
        .catch(function () {});
    }
    render(term, r) {
      var queries = r.queries || [], products = r.products || [], pages = (r.collections || []).concat(r.pages || []);
      var g1 = '', g2 = '';
      function list(cls, title, items) {
        return '<div class="results results--' + cls + '"><h3 class="h4">' + esc(title) + '</h3><ul>' + items + '</ul></div>';
      }
      if (queries.length) {
        g1 += list('queries', eight.strings.suggestions || 'Suggestions', queries.map(function (q) {
          return '<li><a href="' + esc(q.url) + '"><span>' + (q.styled_text || esc(q.text)) + '</span></a></li>';
        }).join(''));
      }
      if (pages.length) {
        g1 += list('pages', eight.strings.pages || 'Pages', pages.map(function (p) {
          return '<li><a href="' + esc(p.url) + '"><span>' + esc(p.title) + '</span></a></li>';
        }).join(''));
      }
      if (products.length) {
        g2 = list('products', eight.strings.products || 'Products', products.map(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          if (img) img = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=240';
          var priceHtml = '';
          if (eight.settings.searchPrice) {
            var price = parseFloat(p.price) * 100, compare = parseFloat(p.compare_at_price_max || 0) * 100;
            priceHtml = '<span class="grid-product__price' + (compare > price ? ' on-sale' : '') + '">' + eight.formatMoney(Math.round(price)) + '</span>';
          }
          return '<li><a href="' + esc(p.url) + '">' +
            '<div class="results-products__image">' + (img ? '<img src="' + esc(img) + '" alt="" width="80" height="80">' : '') + '</div>' +
            '<div class="results-products__info"><span>' + esc(p.title) + '</span>' +
            (eight.settings.searchVendor && p.vendor ? '<span class="predictive__vendor">' + esc(p.vendor) + '</span>' : '') +
            priceHtml + '</div></a></li>';
        }).join(''));
      }
      var html;
      if (!g1 && !g2) {
        /* nothing found: Impulse offers a single link to the full search, nothing else */
        html = '<div class="predictive-search-results predictive-search-results--none"><div class="results">' +
          '<a class="predictive-search__no-results" href="' + esc(eight.routes.search) + '?q=' + encodeURIComponent(term) + '">' +
          esc(unesc(eight.strings.searchFor || 'Search for "{{ terms }}"').replace('{{ terms }}', term)) + '</a></div></div>';
      } else {
        html = '<div class="predictive-search-results">' + (g1 ? '<div class="results__group-1">' + g1 + '</div>' : '') +
          (g2 ? '<div class="results__group-2">' + g2 + '</div>' : '') + '</div>';
        var href = esc(eight.routes.search) + '?q=' + encodeURIComponent(term) + '&options[prefix]=last&type=product';
        html += '<button type="button" class="results__search-btn" data-href="' + href + '">' +
          esc((eight.strings.allResults || 'Show all results for "{{ terms }}"').replace('{{ terms }}', term)) +
          ' <svg aria-hidden="true" focusable="false" viewBox="0 0 14 10" class="results__search-arrow"><path d="M0 5h12.5M8.5 1l4 4-4 4"/></svg></button>';
      }
      this.results.innerHTML = html;
      this.results.hidden = false;
      var btn = this.results.querySelector('.results__search-btn');
      if (btn) btn.addEventListener('click', function () { window.location.href = btn.getAttribute('data-href').replace(/&amp;/g, '&'); });
    }
  }
  customElements.define('eight-search', EightSearch);

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-search]');
    if (!opener) return;
    var panel = document.querySelector('eight-search');
    if (!panel || eight.isPhone() && !panel.input) return;
    e.preventDefault();
    panel.open();
  });
})();

/* ==========================================================================
   Cart: add / change through Shopify's AJAX API, cart drawer, header dot.
   When Eight Cart (our own app) is on the store it takes over the drawer:
   it listens to the same /cart/add.js calls, so the theme only adds.
   ========================================================================== */
(function () {
  'use strict';
  var eight = window.eight;

  function eightCartActive() { return !!(window.EightCart && typeof window.EightCart.open === 'function'); }

  eight.cart = {
    external: eightCartActive,
    add: function (body) {
      var isForm = body instanceof FormData;
      return fetch(eight.routes.cartAdd + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: isForm ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: isForm ? body : JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (j) {
        if (j && j.status && j.status >= 400) throw new Error(j.description || j.message || eight.strings.cartError);
        document.dispatchEvent(new CustomEvent('cart:added', { detail: j }));
        return eight.cart.afterChange(true).then(function () { return j; });
      });
    },
    change: function (key, quantity) {
      return fetch(eight.routes.cartChange + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(function (j) {
        if (j && j.status && j.status >= 400) throw new Error(j.description || j.message);
        return eight.cart.afterChange(false);
      });
    },
    updateNote: function (note) {
      return fetch(eight.routes.cartUpdate + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note })
      });
    },
    get: function () { return fetch(eight.routes.cart + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); },
    afterChange: function (openAfter) {
      return eight.cart.get().then(function (cart) {
        eight.qa('[data-cart-bubble]').forEach(function (b) { b.classList.toggle('cart-link__bubble--visible', cart.item_count > 0); });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        if (eightCartActive()) return cart;                // Eight Cart opens and paints itself
        if (eight.settings.cartType === 'drawer') {
          return eight.cart.refreshDrawer().then(function () {
            if (openAfter) eight.cart.openDrawer();
            return cart;
          });
        }
        if (openAfter) window.location.href = eight.routes.cart;
        return cart;
      });
    },
    refreshDrawer: function () {
      var drawer = document.getElementById('CartDrawer');
      if (!drawer) return Promise.resolve();
      return eight.fetchSection('cart-drawer', eight.routes.root).then(function (doc) {
        var fresh = doc.querySelector('#CartDrawer .drawer__contents');
        var cur = drawer.querySelector('.drawer__contents');
        if (fresh && cur) cur.replaceWith(fresh);
      });
    },
    openDrawer: function () {
      if (eightCartActive()) { window.EightCart.open(); return; }
      var d = document.getElementById('CartDrawer');
      if (d && d.open) d.open();
    }
  };

  /* Header cart icon opens the drawer instead of the cart page */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-open-cart]');
    if (!a || eight.settings.cartType !== 'drawer') return;
    if (eightCartActive()) return;                          // Eight Cart catches this click itself
    e.preventDefault();
    eight.cart.openDrawer();
  });

  /* Quantity + remove inside the cart drawer and cart page */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-qty]');
    if (!btn) return;
    e.preventDefault();
    var row = btn.closest('[data-cart-item]');
    var key = row.getAttribute('data-key');
    var input = row.querySelector('[data-cart-qty-input]');
    var q = parseInt(input ? input.value : row.getAttribute('data-qty'), 10) || 0;
    var dir = btn.getAttribute('data-cart-qty');
    q = dir === 'plus' ? q + 1 : dir === 'minus' ? Math.max(0, q - 1) : 0;
    row.classList.add('is-loading');
    eight.cart.change(key, q).then(function () {
      if (document.body.classList.contains('template-cart')) window.location.reload();
    }).catch(function (err) { row.classList.remove('is-loading'); eight.toast(err.message || eight.strings.cartError); });
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty-input]');
    if (input) {
      var row = input.closest('[data-cart-item]');
      row.classList.add('is-loading');
      eight.cart.change(row.getAttribute('data-key'), parseInt(input.value, 10) || 0).then(function () {
        if (document.body.classList.contains('template-cart')) window.location.reload();
      });
    }
    var note = e.target.closest('[data-cart-note]');
    if (note) eight.cart.updateNote(note.value);
  });

  /* Terms checkbox blocks checkout until ticked */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cart-form]');
    if (!form) return;
    var terms = form.querySelector('[data-cart-terms]');
    if (terms && !terms.checked) {
      e.preventDefault();
      var msg = form.querySelector('[data-terms-error]');
      if (msg) msg.hidden = false;
    }
  });
})();

/* ==========================================================================
   Small UI pieces: footer folds on phones, generic collapsibles
   ========================================================================== */
(function () {
  'use strict';
  var eight = window.eight;
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-footer-fold], [data-collapsible-trigger]');
    if (!t) return;
    var panel = document.getElementById(t.getAttribute('aria-controls'));
    if (!panel) return;
    var open = t.getAttribute('aria-expanded') === 'true';
    t.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (open) {
      panel.style.height = panel.scrollHeight + 'px';
      requestAnimationFrame(function () { panel.style.height = '0px'; panel.classList.remove('is-open'); });
    } else {
      panel.style.height = panel.scrollHeight + 'px';
      panel.classList.add('is-open');
      var done = function (ev) {
        if (ev.target !== panel || ev.propertyName !== 'height') return;
        panel.style.height = 'auto'; panel.removeEventListener('transitionend', done);
      };
      panel.addEventListener('transitionend', done);
    }
  });
})();

/* ==========================================================================
   Product tiles: quick add, quick view (product.modal template), colour dots
   ========================================================================== */
(function () {
  'use strict';
  var eight = window.eight;

  /* ---------- <eight-modal> ---------- */
  class EightModal extends HTMLElement {
    connectedCallback() {
      var self = this;
      this._close = this.close.bind(this);
      this.addEventListener('click', function (e) {
        if (e.target === self || e.target.closest('[data-close-modal]')) self.close();
      });
    }
    fill(html) {
      var content = this.querySelector('[data-modal-content]');
      if (!content) return;
      content.innerHTML = html;
      eight.runScripts(content);
    }
    open(html) {
      eight.closeAll();
      if (html !== undefined) this.fill(html);
      this.hidden = false;
      var self = this;
      requestAnimationFrame(function () { self.classList.add('modal--is-active'); });
      eight.lock('.5s');
      eight.closers.push(this._close);
      this.dispatchEvent(new CustomEvent('modal:open', { bubbles: true }));
    }
    close() {
      if (this.hidden) return;
      this.classList.remove('modal--is-active');
      this.hidden = true;
      eight.unlock();
      eight.closers = eight.closers.filter(function (fn) { return fn !== this._close; }, this);
    }
  }
  customElements.define('eight-modal', EightModal);

  /* Scripts inside HTML injected with innerHTML do not run; re-create them */
  eight.runScripts = function (root) {
    eight.qa('script', root).forEach(function (old) {
      var s = document.createElement('script');
      Array.prototype.slice.call(old.attributes).forEach(function (a) { s.setAttribute(a.name, a.value); });
      s.textContent = old.textContent;
      old.replaceWith(s);
    });
  };

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-quick-add]');
    if (add) {
      e.preventDefault();
      add.classList.add('is-loading');
      eight.cart.add({ items: [{ id: parseInt(add.getAttribute('data-quick-add'), 10), quantity: 1 }] })
        .catch(function (err) { eight.toast(err.message); })
        .then(function () { add.classList.remove('is-loading'); });
      return;
    }
    var view = e.target.closest('[data-quick-view]');
    if (view) {
      e.preventDefault();
      var url = view.getAttribute('data-quick-view');
      var modal = document.getElementById('QuickView');
      if (!modal) { window.location.href = url; return; }
      // the card opens at once; the product fills it as soon as it is there
      var ready = false;
      var pr = quickFetch(url);
      pr.then(function () { ready = true; }, function () {});
      Promise.resolve().then(function () {
        if (!ready) modal.open('<div class="quick-view__loading"><div class="placeholder-content"></div></div>');
        return pr;
      })
        .then(function (main) {
          if (!main) { window.location.href = url; return; }
          if (modal.hidden) modal.open(main.outerHTML); else modal.fill(main.outerHTML);
          document.dispatchEvent(new CustomEvent('quickview:loaded', { detail: { root: modal } }));
        })
        .catch(function () { window.location.href = url; });
    }
  });

  /* The quick view is fetched as soon as a tile is hovered, so the click opens it at once */
  var quickCache = {};
  function quickFetch(url) {
    if (quickCache[url]) return quickCache[url];
    var pr = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var main = doc.querySelector('[data-product-section]');
        if (!main) return null;
        // same product section as the product page, minus what only belongs on the page itself
        main.setAttribute('data-history', 'false');
        main.id = main.id + '-quick';
        main.querySelectorAll('[data-sticky-atc], script[type="application/ld+json"], .product__dots').forEach(function (n) { n.remove(); });
        main.querySelectorAll('[id]').forEach(function (n) { if (n !== main && !/^(ProductForm|ProductSelect|SingleOption|Product-content|Quantity)/.test(n.id)) return; n.id = n.id + '-q'; });
        main.querySelectorAll('[form]').forEach(function (n) { n.setAttribute('form', n.getAttribute('form') + '-q'); });
        main.querySelectorAll('[for]').forEach(function (n) { n.setAttribute('for', n.getAttribute('for') + '-q'); });
        main.querySelectorAll('[aria-controls]').forEach(function (n) { n.setAttribute('aria-controls', n.getAttribute('aria-controls') + '-q'); });
        return main;
      });
    pr.catch(function () { delete quickCache[url]; });
    quickCache[url] = pr;
    return pr;
  }
  document.addEventListener('mouseover', function (e) {
    var tile = e.target.closest && e.target.closest('.grid-product');
    var q = tile && tile.querySelector('[data-quick-view]');
    if (q && document.getElementById('QuickView')) quickFetch(q.getAttribute('data-quick-view')).catch(function () {});
  });

  /* Hover a colour dot: show that colour's image on the tile */
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest('[data-variant-image]');
    if (!sw) return;
    var tile = sw.closest('.grid-product');
    var img = tile && tile.querySelector('.grid-product__image');
    if (!img) return;
    if (!img.dataset.original) img.dataset.original = img.currentSrc || img.src;
    img.removeAttribute('srcset');
    img.src = sw.getAttribute('data-variant-image');
  });
})();

/* ==========================================================================
   Slideshow (fading hero) and carousel (scroll-snap rows with dots)
   ========================================================================== */
(function () {
  'use strict';
  var eight = window.eight;

  class EightSlideshow extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.slides = eight.qa('.slideshow__slide', this);
      this.dots = eight.qa('.slideshow__dot', this);
      this.index = 0;
      // 'loaded' once the first image is in: that starts the slide-in and the text
      var first = this.slides[0] && this.slides[0].querySelector('img');
      var done = function () { self.classList.add('loaded'); };
      if (!first || first.complete) requestAnimationFrame(done);
      else { first.addEventListener('load', done, { once: true }); first.addEventListener('error', done, { once: true }); }
      if (this.slides.length < 2) return;
      this.addEventListener('click', function (e) {
        var d = e.target.closest('[data-go]');
        if (d) { self.go(parseInt(d.getAttribute('data-go'), 10)); self.restart(); }
        var a = e.target.closest('[data-step]');
        if (a) { self.go(self.index + parseInt(a.getAttribute('data-step'), 10)); self.restart(); }
      });
      var x0 = null;
      this.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) { self.go(self.index + (dx < 0 ? 1 : -1)); self.restart(); }
      });
      this.restart();
      // In the theme editor, show the slide being edited
      document.addEventListener('shopify:block:select', function (e) {
        var i = self.slides.indexOf(e.target);
        if (i > -1) { self.go(i); clearInterval(self.timer); }
      });
    }
    disconnectedCallback() { clearInterval(this.timer); }
    restart() {
      var self = this;
      clearInterval(this.timer);
      if (this.getAttribute('data-autoplay') !== 'true' || eight.reducedMotion()) return;
      var ms = parseInt(this.getAttribute('data-speed'), 10) || 7000;
      this.timer = setInterval(function () { if (!document.hidden) self.go(self.index + 1); }, ms);
    }
    go(i) {
      var n = this.slides.length;
      i = (i + n) % n;
      if (i === this.index) return;
      var out = this.slides[this.index];
      out.classList.add('animate-out');
      setTimeout(function () { out.classList.remove('animate-out'); }, 600);
      this.slides[this.index].classList.remove('is-selected');
      if (this.dots[this.index]) this.dots[this.index].classList.remove('is-selected');
      this.index = i;
      this.slides[i].classList.add('is-selected');
      if (this.dots[i]) this.dots[i].classList.add('is-selected');
    }
  }
  customElements.define('eight-slideshow', EightSlideshow);

  /* Calls back once a background video actually plays (YouTube/Vimeo by their message API, or a <video>);
     never later than 8s, so a video that never starts still lets its text in */
  function onPlaying(media, cb) {
    var done = false, fire = function () { if (done) return; done = true; if (!media.hasAttribute || !media.hasAttribute('data-loop')) window.removeEventListener('message', msg); cb(); };
    setTimeout(fire, 8000);
    if (media.tagName === 'VIDEO') {
      if (!media.paused && media.readyState > 2) fire(); else media.addEventListener('playing', fire, { once: true });
      return;
    }
    var yt = /youtube/.test(media.src), vimeo = /vimeo/.test(media.src);
    function msg(e) {
      if (e.source !== media.contentWindow) return;
      var d = e.data;
      try { if (typeof d === 'string') d = JSON.parse(d); } catch (err) { return; }
      if (!d) return;
      var st = d.info && typeof d.info === 'object' ? d.info.playerState : (d.event === 'onStateChange' ? d.info : null);
      if (yt && st === 1) fire();
      // loop through the player itself: a playlist-loop makes YouTube draw its own controls over the video
      if (yt && st === 0 && media.hasAttribute('data-loop')) {
        media.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'seekTo', args: [0, true], id: 1, channel: 'widget' }), '*');
        media.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo', args: [], id: 1, channel: 'widget' }), '*');
      }
      if (vimeo) {
        if (d.event === 'ready') media.contentWindow.postMessage(JSON.stringify({ method: 'addEventListener', value: 'play' }), '*');
        if (d.event === 'play' || d.event === 'playProgress') fire();
      }
    }
    window.addEventListener('message', msg);
    media.addEventListener('load', function () {
      if (!yt) return;
      media.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: 1, channel: 'widget' }), '*');
      media.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'addEventListener', args: ['onStateChange'], id: 1, channel: 'widget' }), '*');
    });
  }
  eight.onPlaying = onPlaying;

  /* Video hero: the video zooms in and the text rises once it plays */
  class EightHeroVideo extends HTMLElement {
    connectedCallback() {
      var self = this;
      var media = this.querySelector('.hero__media iframe, .hero__media video');
      var loaded = function () { self.classList.remove('loading'); self.classList.add('loaded'); };
      this.classList.add('loading');
      if (!media) { loaded(); return; }
      onPlaying(media, loaded);
      if (media.tagName === 'VIDEO') return;
      this.size = function () {
        var r = self.getBoundingClientRect(), w = r.width, h = r.height, st = media.style;
        if (!w || !h) return;
        if (w / h > 16 / 9) { st.width = w + 'px'; st.height = h * 3 + 'px'; st.left = '0px'; st.top = -h + 'px'; }
        else { st.width = w * 3 + 'px'; st.height = h + 'px'; st.left = -w + 'px'; st.top = '0px'; }
      };
      this.size();
      window.addEventListener('resize', this.size);
    }
    disconnectedCallback() { if (this.size) window.removeEventListener('resize', this.size); }
  }
  customElements.define('eight-hero-video', EightHeroVideo);

  /* 'loaded' on a media section once its image is in or its video plays; 'aos-animate' once it is 120px into view */
  function mediaLoaded(el) {
    var add = function () { el.classList.add('loaded'); };
    var v = el.querySelector('iframe, video');
    if (v) { el.classList.add('loading'); onPlaying(v, function () { el.classList.remove('loading'); add(); }); return; }
    var img = el.querySelector('img');
    if (!img || img.complete) add();
    else { img.addEventListener('load', add, { once: true }); img.addEventListener('error', add, { once: true }); }
  }
  var aosIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('aos-animate'); aosIO.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -120px 0px' }) : null;
  function scan(root) {
    eight.qa('[data-media-loaded]', root).forEach(function (el) { if (!el._ml) { el._ml = 1; mediaLoaded(el); } });
    eight.qa('[data-aos]', root).forEach(function (el) { if (el._aos) return; el._aos = 1; el.classList.add('aos-init'); if (aosIO) aosIO.observe(el); else el.classList.add('aos-animate'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); }); else scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });

  /* Parallax: on every scroll the image is sized 15% past its own current size along the movement and
     shifted by how far the image has travelled through the screen */
  class EightParallax extends HTMLElement {
    connectedCallback() {
      var img = this.querySelector('.parallax-image');
      if (!img) return;
      var left = img.getAttribute('data-angle') === 'left';
      var move = (parseFloat(img.getAttribute('data-movement')) || 15) / 100;
      this.update = function () {
        var r = img.getBoundingClientRect(), vh = window.innerHeight, st = img.style;
        var e = Math.ceil((left ? r.width : r.height) * move);
        var t = -e * (vh - r.top) / (vh + r.height);
        if (left) { st.left = '0px'; st.bottom = '0px'; st.width = 'calc(100% + ' + e + 'px)'; st.transform = 'translate3d(' + t + 'px, 0px, 0px)'; }
        else { st.right = '0px'; st.top = '0px'; st.height = 'calc(100% + ' + e + 'px)'; st.transform = 'translate3d(0px, ' + t + 'px, 0px)'; }
      };
      this.update();
      window.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update);
    }
    disconnectedCallback() {
      if (!this.update) return;
      window.removeEventListener('scroll', this.update);
      window.removeEventListener('resize', this.update);
    }
  }
  customElements.define('eight-parallax', EightParallax);

  class EightCarousel extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.track = this.querySelector('.carousel__track');
      this.slides = eight.qa('.carousel__slide', this);
      this.dots = eight.qa('.carousel__dot', this);
      if (!this.track || !this.slides.length) return;
      this.center = this.hasAttribute('data-center');
      this.addEventListener('click', function (e) {
        var d = e.target.closest('[data-go]');
        if (d) { self.go(parseInt(d.getAttribute('data-go'), 10)); self.restart(); }
        var a = e.target.closest('[data-step]');
        if (a) { self.go(self.index + parseInt(a.getAttribute('data-step'), 10)); self.restart(); }
        var s = e.target.closest('.carousel__slide');
        if (s && self.center && !s.classList.contains('is-selected')) self.go(self.slides.indexOf(s));
      });
      this.track.addEventListener('scroll', eight.debounce(function () { self.sync(); }, 60), { passive: true });
      this.addEventListener('pointerdown', function () { clearInterval(self.timer); });
      // Start on the second slide when centring, like a carousel with neighbours on both sides
      var start = this.center && this.slides.length > 2 ? 1 : 0;
      requestAnimationFrame(function () { self.go(start, true); self.restart(); });
      // keep the slide in focus where it was when the screen turns or resizes
      window.addEventListener('resize', eight.debounce(function () { self.go(self.index || 0, true); }, 120));
    }
    disconnectedCallback() { clearInterval(this.timer); }
    restart() {
      var self = this, ms = parseInt(this.getAttribute('data-autoplay'), 10);
      clearInterval(this.timer);
      if (!ms || eight.reducedMotion()) return;
      this.timer = setInterval(function () {
        if (!document.hidden) self.go((self.index + 1) % self.slides.length);
      }, ms);
    }
    go(i, instant) {
      var s = this.slides[i];
      if (!s) return;
      var left = s.offsetLeft - (this.center ? (this.track.clientWidth - s.offsetWidth) / 2 : 0);
      this.track.scrollTo({ left: left, behavior: instant ? 'auto' : 'smooth' });
      this.mark(i);
    }
    sync() {
      var mid = this.track.scrollLeft + this.track.clientWidth / 2, best = 0, bestD = Infinity;
      this.slides.forEach(function (s, i) {
        var c = s.offsetLeft + s.offsetWidth / 2, d = Math.abs(c - mid);
        if (d < bestD) { bestD = d; best = i; }
      });
      this.mark(best);
    }
    mark(i) {
      this.index = i;
      this.slides.forEach(function (s, j) { s.classList.toggle('is-selected', j === i); });
      this.dots.forEach(function (d, j) { d.classList.toggle('is-selected', j === i); });
      // the row is as tall as the slide in focus, not the tallest one
      if (this.center && this.slides[i]) this.track.style.height = this.slides[i].getBoundingClientRect().height + 'px';
    }
  }
  customElements.define('eight-carousel', EightCarousel);
})();

/* ==========================================================================
   Product page: variant selection, gallery, zoom, add to cart
   ========================================================================== */
(function () {
  'use strict';
  var eight = window.eight;

  /* ---------- <eight-gallery> ---------- */
  class EightGallery extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = eight.qa('.product-main-slide', this);
      this.thumbs = eight.qa('[data-thumb]', this);
      this.dots = eight.qa('.product__dot', this);
      this.index = parseInt(this.getAttribute('data-start'), 10) || 0;
      // the viewer is fetched while the page settles, so the first zoom opens at once
      if (this.getAttribute('data-zoom') === 'true') (window.requestIdleCallback || setTimeout)(function () { loadPhotoSwipe().catch(function () {}); });
      this.addEventListener('click', function (e) {
        var t = e.target.closest('[data-thumb]');
        if (t) { e.preventDefault(); self.go(parseInt(t.getAttribute('data-thumb'), 10)); return; }
        if (e.target.closest('[data-thumb-prev]')) { self.go(self.index - 1); return; }
        if (e.target.closest('[data-thumb-next]')) { self.go(self.index + 1); return; }
        var z = e.target.closest('.js-photoswipe__zoom');
        if (z && self.getAttribute('data-zoom') === 'true') { e.preventDefault(); self.zoom(parseInt(z.getAttribute('data-zoom-index'), 10)); }
      });
      if (this.track) {
        this.track.addEventListener('scroll', eight.debounce(function () {
          if (!eight.isPhone()) return;
          var i = Math.round(self.track.scrollLeft / self.track.clientWidth);
          self.mark(i);
        }, 60), { passive: true });
      }
      if (this.index && eight.isPhone() && this.track) {
        requestAnimationFrame(function () { self.track.scrollLeft = self.index * self.track.clientWidth; });
      }
    }
    go(i) {
      var n = this.slides.length;
      if (!n) return;
      i = (i + n) % n;
      if (eight.isPhone() && this.track) this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
      this.mark(i);
    }
    goToMedia(mediaId) {
      var i = this.slides.findIndex(function (s) { return s.getAttribute('data-media-id') == mediaId; });
      if (i > -1) this.go(i);
    }
    mark(i) {
      this.index = i;
      this.slides.forEach(function (s, j) { s.classList.toggle('is-selected', j === i); });
      this.thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
      this.dots.forEach(function (d, j) { d.classList.toggle('is-selected', j === i); });
      var active = this.thumbs[i];
      if (active) {
        var sc = active.closest('.product__thumbs--scroller');
        if (sc) {
          var item = active.parentElement;
          if (sc.scrollWidth > sc.clientWidth) sc.scrollTo({ left: item.offsetLeft - sc.clientWidth / 2 + item.offsetWidth / 2, behavior: 'smooth' });
          else if (sc.scrollHeight > sc.clientHeight) sc.scrollTo({ top: item.offsetTop - sc.clientHeight / 2 + item.offsetHeight / 2, behavior: 'smooth' });
        }
      }
      // pause videos that are no longer visible
      this.slides.forEach(function (s, j) { if (j !== i) { var v = s.querySelector('video'); if (v) v.pause(); } });
    }
    zoom(i) {
      var self = this;
      var buttons = eight.qa('.js-photoswipe__zoom', this);
      var items = buttons.map(function (b, j) {
        var img = self.slides[j] && self.slides[j].querySelector('img');
        return { src: b.getAttribute('data-zoom-src'), w: +b.getAttribute('data-zoom-w'), h: +b.getAttribute('data-zoom-h'), msrc: img ? (img.currentSrc || img.src) : '', el: img };
      });
      eight.lightbox(items, i);
    }
  }
  customElements.define('eight-gallery', EightGallery);

  /* ---------- full-screen image viewer (PhotoSwipe core, loaded on first use) ---------- */
  var CHEV = { left: '<svg class="icon" viewBox="0 0 7.4 13" aria-hidden="true" focusable="false"><path d="M6.4 0l1 1-5.5 5.5L7.4 12l-1 1L0 6.5z"/></svg>',
    right: '<svg class="icon" viewBox="0 0 7.4 13" aria-hidden="true" focusable="false"><path d="M1 0L0 1l5.5 5.5L0 12l1 1 6.4-6.5z"/></svg>' };
  var CLOSE = '<svg class="icon" viewBox="0 0 64 64" aria-hidden="true" focusable="false"><path d="M18.5 18.5l27 27M45.5 18.5l-27 27" stroke-width="2"/></svg>';
  var pswpLoad;
  function loadPhotoSwipe() {
    if (window.PhotoSwipe) return Promise.resolve();
    if (!pswpLoad) pswpLoad = new Promise(function (ok, fail) {
      var sc = document.createElement('script'); sc.src = eight.assets && eight.assets.photoswipe; sc.onload = ok; sc.onerror = fail;
      document.head.appendChild(sc);
    });
    return pswpLoad;
  }
  function pswpRoot() {
    var el = document.querySelector('.pswp');
    if (el) return el;
    el = document.createElement('div');
    el.className = 'pswp'; el.setAttribute('tabindex', '-1'); el.setAttribute('role', 'dialog'); el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<div class="pswp__bg"></div><div class="pswp__scroll-wrap"><div class="pswp__container">' +
      '<div class="pswp__item"></div><div class="pswp__item"></div><div class="pswp__item"></div></div>' +
      '<div class="pswp__ui pswp__ui--hidden">' +
      '<button type="button" class="btn btn--body btn--circle pswp__button pswp__button--arrow--left" title="' + (eight.strings.previous || 'Previous') + '">' + CHEV.left + '</button>' +
      '<button type="button" class="btn btn--body btn--circle btn--large pswp__button pswp__button--close" title="' + (eight.strings.closeEsc || 'Close (esc)') + '">' + CLOSE + '</button>' +
      '<button type="button" class="btn btn--body btn--circle pswp__button pswp__button--arrow--right" title="' + (eight.strings.next || 'Next') + '">' + CHEV.right + '</button>' +
      '</div></div>';
    document.body.appendChild(el);
    return el;
  }
  // the controls: three round buttons that rise from the bottom once the image is open
  function PswpUI(pswp) {
    this.init = function () {
      var root = pswp.template, ui = root.querySelector('.pswp__ui');
      root.classList.toggle('pswp--single', pswp.items.length < 2);
      function click(e) {
        if (e.target.closest('.pswp__button--close')) pswp.close();
        else if (e.target.closest('.pswp__button--arrow--left')) pswp.prev();
        else if (e.target.closest('.pswp__button--arrow--right')) pswp.next();
      }
      ui.addEventListener('click', click);
      pswp.listen('parseVerticalMargin', function (item) { item.vGap = { top: 44, bottom: 0 }; });
      requestAnimationFrame(function () { ui.classList.remove('pswp__ui--hidden'); });
      pswp.listen('close', function () { ui.classList.add('pswp__ui--hidden'); });
      pswp.listen('destroy', function () { ui.removeEventListener('click', click); });
    };
  }
  eight.lightbox = function (items, start) {
    loadPhotoSwipe().then(function () {
      var el = pswpRoot();
      var g = new window.PhotoSwipe(el, PswpUI, items.map(function (it) { return { src: it.src, w: it.w, h: it.h, msrc: it.msrc, el: it.el }; }), {
        index: start || 0, history: false, bgOpacity: 1,
        getThumbBoundsFn: function (i) {
          var im = items[i] && items[i].el;
          if (!im) return null;
          var r = im.getBoundingClientRect();
          return { x: r.left, y: r.top + (window.pageYOffset || document.documentElement.scrollTop), w: r.width };
        }
      });
      g.init();
    }).catch(function () { if (items[start || 0]) window.open(items[start || 0].src, '_blank'); });
  };

  /* ---------- <eight-product> ---------- */
  class EightProduct extends HTMLElement {
    connectedCallback() {
      var self = this;
      // a store's own code block with one closing tag too many can end this element early; the data then sits right after it
      var json = this.querySelector('[data-product-json]') || document.getElementById('ProductJson-' + this.getAttribute('data-section-id'));
      try { this.product = JSON.parse(json.textContent); } catch (e) { this.product = null; }
      if (!this.product) return;
      this.history = this.getAttribute('data-history') === 'true';
      this.addEventListener('change', function (e) {
        if (e.target.matches('[data-variant-input]')) self.onOptionChange();
      });
      this.addEventListener('submit', function (e) {
        var form = e.target.closest('[data-product-form]');
        if (!form) return;
        e.preventDefault();
        self.addToCart(form);
      });
      // Start the add from the button itself: some apps swallow the form's submit event on its way up,
      // which left the button dead whenever Eight Cart was not there to catch it first.
      this.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-add-to-cart]');
        if (!btn || btn.disabled) return;
        var form = btn.form || btn.closest('form');
        if (!form || !form.matches('[data-product-form]')) return;
        e.preventDefault();
        if (form.reportValidity && !form.reportValidity()) return;
        self.addToCart(form);
      });
      this.addEventListener('click', function (e) {
        var q = e.target.closest('[data-qty]');
        if (!q) return;
        var input = q.parentElement.querySelector('input');
        var v = parseInt(input.value, 10) || 1;
        input.value = q.getAttribute('data-qty') === 'plus' ? v + 1 : Math.max(1, v - 1);
      });
      this.markUnavailable();
    }
    selectedOptions() {
      var opts = [];
      eight.qa('[data-variant-input]', this).forEach(function (input) {
        var i = parseInt(String(input.getAttribute('data-index')).replace('option', ''), 10) - 1;
        if (input.type === 'radio') { if (input.checked) opts[i] = input.value; }
        else opts[i] = input.value;
      });
      return opts;
    }
    findVariant(opts) {
      return this.product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === undefined || o === opts[i]; });
      });
    }
    onOptionChange() {
      var opts = this.selectedOptions();
      var v = this.findVariant(opts);
      this.markUnavailable();
      eight.qa('[data-option-index]', this).forEach(function (fs) {
        var lbl = fs.querySelector('[data-option-value]');
        var i = parseInt(fs.getAttribute('data-option-index'), 10);
        if (lbl) lbl.textContent = opts[i] || '';
      });
      this.update(v);
    }
    update(v) {
      var idInput = this.querySelector('[data-variant-id]');
      var btn = this.querySelector('[data-add-to-cart]');
      var btnText = this.querySelector('[data-add-to-cart-text]');
      if (!v) {
        if (btn) btn.disabled = true;
        if (btnText) btnText.textContent = eight.strings.unavailable;
        return;
      }
      this.variant = v;
      if (idInput) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      if (btn) btn.disabled = !v.available;
      if (btnText) btnText.textContent = v.available ? eight.strings.addToCart : eight.strings.soldOut;
      // price
      var price = this.querySelector('[data-price]'), compare = this.querySelector('[data-compare-price]');
      var saving = this.querySelector('[data-savings]');
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (price) { price.textContent = eight.formatMoney(v.price) + '\n'; price.classList.toggle('on-sale', !!onSale); }
      if (compare) { compare.hidden = !onSale; compare.textContent = onSale ? eight.formatMoney(v.compare_at_price) : ''; }
      eight.qa('[data-compare-label],[data-sale-label]', this).forEach(function (l) { l.hidden = !onSale; });
      if (saving) {
        saving.hidden = !onSale;
        if (onSale) {
          var amt = eight.settings.saveType === 'dollar' ? eight.formatMoney(v.compare_at_price - v.price)
            : Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
          saving.textContent = (eight.strings.save || 'Save') + ' ' + amt;
        }
      }
      var unit = this.querySelector('[data-unit-price]');
      if (unit) {
        unit.hidden = !v.unit_price_measurement;
        if (v.unit_price_measurement) {
          var m = v.unit_price_measurement;
          unit.textContent = eight.formatMoney(v.unit_price) + '/' + (m.reference_value !== 1 ? m.reference_value : '') + m.reference_unit;
        }
      }
      var sku = this.querySelector('[data-sku]');
      if (sku) { sku.hidden = !v.sku; sku.lastChild.textContent = v.sku || ''; }
      // gallery
      if (v.featured_media) {
        var g = this.querySelector('eight-gallery');
        if (g && g.goToMedia) g.goToMedia(v.featured_media.id);
      }
      // url
      if (this.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: v } }));
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v, product: this.product } }));
    }
    /* Cross out option values that cannot be bought with the other current choices */
    markUnavailable() {
      var picker = this.querySelector('eight-variant-picker');
      if (!picker || picker.getAttribute('data-dynamic') !== 'true') return;
      var product = this.product, opts = this.selectedOptions();
      eight.qa('[data-option-index]', this).forEach(function (fs) {
        var i = parseInt(fs.getAttribute('data-option-index'), 10);
        eight.qa('.variant-input', fs).forEach(function (el) {
          var val = el.getAttribute('data-value');
          var ok = product.variants.some(function (v) {
            return v.available && v.options[i] === val && v.options.every(function (o, j) { return j === i || j > i || opts[j] === undefined || o === opts[j]; });
          });
          el.classList.toggle('is-unavailable', !ok);
          var input = el.querySelector('input');
          if (input) input.classList.toggle('disabled', !ok);
        });
        eight.qa('option', fs).forEach(function (o) {
          var ok = product.variants.some(function (v) {
            return v.available && v.options[i] === o.value && v.options.every(function (opt, j) { return j === i || j > i || opts[j] === undefined || opt === opts[j]; });
          });
          o.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    addToCart(form) {
      var btn = form.querySelector('[data-add-to-cart]');
      var err = form.querySelector('[data-form-error]');
      // with Eight Cart on the store the cart itself shows the progress, the button stays as it is
      if (btn && !eight.cart.external()) btn.classList.add('btn--loading');
      if (err) err.hidden = true;
      var fd = new FormData(form);
      var qty = this.querySelector('input[name="quantity"]');
      if (qty && !fd.get('quantity')) fd.set('quantity', qty.value);
      eight.cart.add(fd).catch(function (e) {
        if (err) { err.textContent = e.message; err.hidden = false; } else eight.toast(e.message);
      }).then(function () { if (btn) btn.classList.remove('btn--loading'); });
    }
  }
  customElements.define('eight-product', EightProduct);

  /* Standalone modal openers (size chart pages, etc.) */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open-modal]');
    if (!o) return;
    var m = document.getElementById(o.getAttribute('data-open-modal'));
    if (m && m.open) { e.preventDefault(); m.open(); }
  });

  /* Recently viewed: remember this product */
  document.addEventListener('DOMContentLoaded', function () {
    var p = document.querySelector('eight-product[data-history="true"]');
    if (!p) return;
    try {
      var h = p.getAttribute('data-product-url').split('?')[0].split('/products/')[1];
      var list = JSON.parse(localStorage.getItem('eight-recent') || '[]').filter(function (x) { return x !== h; });
      list.unshift(h);
      localStorage.setItem('eight-recent', JSON.stringify(list.slice(0, 12)));
    } catch (e) {}
  });
})();

/* ==========================================================================
   Collection + search results: filters and sorting without a page reload
   ========================================================================== */
(function () {
  'use strict';
  var eight = window.eight;

  class EightCollection extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.sectionId = this.getAttribute('data-section-id');
      this.addEventListener('change', function (e) {
        if (e.target.closest('[data-filter-form]')) self.fromForm(e.target.closest('[data-filter-form]'));
        if (e.target.matches('[data-sort]')) {
          var u = new URL(window.location.href);
          u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page');
          self.load(u.toString());
        }
      });
      this.addEventListener('click', function (e) {
        var a = e.target.closest('[data-filter-link]');
        if (a) { e.preventDefault(); self.load(a.href); }
      });
      window.addEventListener('popstate', function () { self.load(window.location.href, true); });
      this.addEventListener('input', function (e) { var r = e.target.closest('[data-price-range]'); if (r) self.priceRange(r, e.target); });
      eight.qa('[data-price-range]', this).forEach(function (r) { self.priceRange(r); });
    }
    priceRange(r, moved) {
      var lo = r.querySelector('[data-price-lo]'), hi = r.querySelector('[data-price-hi]');
      var max = parseInt(r.getAttribute('data-max'), 10) || 0;
      var a = parseInt(lo.value, 10), b = parseInt(hi.value, 10);
      if (a > b) { if (moved === lo) { a = b; lo.value = a; } else { b = a; hi.value = b; } }
      var c = r.querySelector('[data-price-connect]');
      if (c && max) { c.style.left = (a / max * 100) + '%'; c.style.right = (100 - b / max * 100) + '%'; }
      var l1 = r.querySelector('[data-price-min-label]'), l2 = r.querySelector('[data-price-max-label]');
      if (moved) { if (l1) l1.textContent = eight.formatMoney(a); if (l2) l2.textContent = eight.formatMoney(b); }
      r.querySelector('[data-price-lo-field]').value = a > 0 ? (a / 100).toFixed(2) : '';
      r.querySelector('[data-price-hi-field]').value = b < max ? (b / 100).toFixed(2) : '';
    }
    fromForm(form) {
      var fd = new FormData(form), params = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '') params.append(k, v); });
      var u = new URL(window.location.href);
      var sort = u.searchParams.get('sort_by');
      if (sort && !params.has('sort_by')) params.set('sort_by', sort);
      this.load(u.pathname + '?' + params.toString());
    }
    load(url, fromPop) {
      var self = this;
      this.classList.add('is-loading');
      eight.fetchSection(this.sectionId, url).then(function (doc) {
        var fresh = doc.querySelector('eight-collection');
        if (!fresh) { window.location.href = url; return; }
        // keep open/closed state of filter groups the visitor set
        var open = eight.qa('[data-collapsible-trigger]', self).map(function (t) { return t.getAttribute('aria-expanded'); });
        self.innerHTML = fresh.innerHTML;
        eight.qa('[data-price-range]', self).forEach(function (r) { self.priceRange(r); });
        eight.qa('[data-collapsible-trigger]', self).forEach(function (t, i) {
          if (open[i] === undefined) return;
          t.setAttribute('aria-expanded', open[i]);
          var p = document.getElementById(t.getAttribute('aria-controls'));
          if (p) { p.classList.toggle('is-open', open[i] === 'true'); p.style.height = open[i] === 'true' ? 'auto' : '0px'; }
        });
        eight.observeReveal(self);
        if (!fromPop) window.history.pushState({}, '', url);
      }).catch(function () { window.location.href = url; })
        .then(function () { self.classList.remove('is-loading'); });
    }
  }
  customElements.define('eight-collection', EightCollection);
})();

/* ==========================================================================
   Popup with reminder tab, age verification gate, recently viewed, recommendations
   ========================================================================== */
(function () {
  'use strict';
  var eight = window.eight;
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  class EightPopup extends HTMLElement {
    connectedCallback() {
      var self = this, key = 'eight-popup-' + this.getAttribute('data-section-id');
      var test = this.getAttribute('data-test') === 'true' || window.Shopify && Shopify.designMode;
      this.key = key;
      this.reopen = this.querySelector('[data-popup-reopen]');
      this.addEventListener('click', function (e) {
        if (e.target.closest('[data-popup-close]') || e.target.classList.contains('modal')) self.close(true);
        if (e.target.closest('[data-popup-reopen]')) self.show();
        if (e.target.closest('[data-popup-cta]')) store(key + '-done', '1');
      });
      if (this.querySelector('[data-popup-success]')) { store(key + '-done', '1'); this.hidden = false; this.show(); return; }
      if (store(key + '-done') && !test) return;
      var last = parseInt(store(key) || '0', 10);
      var days = parseInt(this.getAttribute('data-days'), 10) || 30;
      if (!test && last && Date.now() - last < days * 864e5) { if (this.reopen) { this.hidden = false; this.reopen.hidden = false; } return; }
      setTimeout(function () { self.hidden = false; self.show(); }, (parseInt(this.getAttribute('data-delay'), 10) || 0) * 1000);
    }
    show() {
      var m = this.querySelector('.modal');
      m.hidden = false;
      requestAnimationFrame(function () { m.classList.add('modal--is-active'); });
      if (this.reopen) this.reopen.hidden = true;
    }
    close(remember) {
      var m = this.querySelector('.modal');
      m.classList.remove('modal--is-active'); m.hidden = true;
      if (remember) store(this.key, String(Date.now()));
      if (this.reopen) this.reopen.hidden = false;
    }
  }
  customElements.define('eight-popup', EightPopup);

  class EightAgeGate extends HTMLElement {
    connectedCallback() {
      var self = this;
      if (store('eight-age-ok') && this.getAttribute('data-test') !== 'true') return;
      this.hidden = false; document.documentElement.classList.add('eight-lock');
      this.addEventListener('click', function (e) {
        if (e.target.closest('[data-age-confirm]')) { store('eight-age-ok', '1'); self.hidden = true; document.documentElement.classList.remove('eight-lock'); }
        if (e.target.closest('[data-age-decline]')) { self.querySelector('[data-age-question]').hidden = true; self.querySelector('[data-age-declined]').hidden = false; }
        if (e.target.closest('[data-age-return]')) { self.querySelector('[data-age-question]').hidden = false; self.querySelector('[data-age-declined]').hidden = true; }
      });
    }
  }
  customElements.define('eight-age-gate', EightAgeGate);

  /* Recently viewed: render tiles for products kept in this browser */
  class EightRecent extends HTMLElement {
    connectedCallback() {
      var self = this, list;
      try { list = JSON.parse(localStorage.getItem('eight-recent') || '[]'); } catch (e) { list = []; }
      var current = this.getAttribute('data-current');
      list = list.filter(function (h) { return h && h !== current; }).slice(0, parseInt(this.getAttribute('data-count'), 10) || 5);
      if (!list.length) return;
      var q = list.map(function (h) { return 'handle:"' + h + '"'; }).join(' OR ');
      var url = eight.routes.search + '?view=recent&type=product&q=' + encodeURIComponent(q);
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var tiles = eight.qa('.grid-product', doc);
        if (!tiles.length) return;
        tiles.sort(function (a, b) { return list.indexOf(a.getAttribute('data-product-handle')) - list.indexOf(b.getAttribute('data-product-handle')); });
        var grid = self.querySelector('[data-recent-grid]');
        tiles.forEach(function (t) { grid.appendChild(t); });
        self.hidden = false; eight.observeReveal(self);
      }).catch(function () {});
    }
  }
  customElements.define('eight-recent', EightRecent);

  /* Product recommendations: Shopify fills them on a second request */
  class EightRecommendations extends HTMLElement {
    connectedCallback() {
      var self = this;
      if (this.querySelector('.grid-product')) return;
      fetch(this.getAttribute('data-url'), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('eight-recommendations');
        if (fresh && fresh.innerHTML.trim()) { self.innerHTML = fresh.innerHTML; eight.observeReveal(self); }
      }).catch(function () {});
    }
  }
  customElements.define('eight-recommendations', EightRecommendations);

  class EightComplementary extends HTMLElement {
    connectedCallback() {
      var self = this;
      fetch(this.getAttribute('data-url'), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var tiles = eight.qa('.grid-product', doc);
        if (!tiles.length) return;
        var h = document.createElement('div'); h.className = 'h4 complementary__title'; h.textContent = self.getAttribute('data-heading');
        var g = document.createElement('div'); g.className = 'grid grid--uniform complementary__grid';
        tiles.forEach(function (t) { t.className = t.className.replace(/medium-up--one-\w+/, 'medium-up--one-third'); g.appendChild(t); });
        self.appendChild(h); self.appendChild(g);
      }).catch(function () {});
    }
  }
  customElements.define('eight-complementary', EightComplementary);
})();

/* ==========================================================================
   Countdown, hotspots, image comparison, YouTube popup, pickup availability
   ========================================================================== */
(function () {
  'use strict';
  var eight = window.eight;

  // Countdown: counts to the set date in the visitor's own timezone. A date that has passed leaves the
  // timer untouched unless "hide timer" is on; then the timer goes and the message shows.
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      var self = this, g = function (k) { return parseInt(self.getAttribute('data-' + k), 10); };
      var end = new Date(g('year'), (g('month') || 1) - 1, g('day') || 1, g('hour') || 0, g('minute') || 0).getTime();
      if (isNaN(end)) return;
      var disp = this.querySelector('[data-time-display]'), msg = this.querySelector('[data-message]');
      var done = function () {
        clearInterval(self.t);
        if (self.getAttribute('data-hide-timer') === 'true') {
          disp.classList.remove('countdown__display--visible'); disp.classList.add('countdown__display--hidden');
          if (msg) msg.classList.add('countdown__timer-message--visible');
        }
      };
      var tick = function () {
        var d = end - Date.now();
        if (d <= 0) { done(); return; }
        self.querySelector('[data-days]').textContent = Math.floor(d / 864e5);
        self.querySelector('[data-hours]').textContent = Math.floor(d / 36e5) % 24;
        self.querySelector('[data-minutes]').textContent = Math.floor(d / 6e4) % 60;
        self.querySelector('[data-seconds]').textContent = Math.floor(d / 1e3) % 60;
        disp.classList.add('countdown__display--loaded');
      };
      tick(); if (end > Date.now()) this.t = setInterval(tick, 1000);
    }
    disconnectedCallback() { clearInterval(this.t); }
  }
  if (!customElements.get('countdown-timer')) customElements.define('countdown-timer', CountdownTimer);

  class EightHotspots extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.addEventListener('click', function (e) {
        var b = e.target.closest('[data-hotspot]');
        if (!b) {
          if (!e.target.closest('.shoppable-hero__card')) eight.qa('.shoppable-hero__spot.is-active', self).forEach(function (s) { s.classList.remove('is-active'); });
          return;
        }
        var id = b.getAttribute('data-hotspot');
        if (!b.closest('.hotspots__buttons')) eight.qa('[data-hotspot]', self).forEach(function (x) { x.classList.toggle('is-active', x === b); });
        eight.qa('[data-hotspot-item]', self).forEach(function (x) { x.classList.toggle('is-active', x.getAttribute('data-hotspot-item') === id); });
        eight.qa('.shoppable-hero__spot', self).forEach(function (s) { s.classList.toggle('is-active', s.contains(b) && !s.classList.contains('is-active')); });
      });
    }
  }
  customElements.define('eight-hotspots', EightHotspots);

  /* Before/after: only the handle drags; the clip follows the pointer's movement, kept 50px from either edge */
  class EightCompare extends HTMLElement {
    connectedCallback() {
      var self = this, drag = this.querySelector('[data-draggable]'), btn = this.querySelector('[data-button]');
      if (!drag || !btn) return;
      var wrap = drag.querySelector('[data-primary-image]');
      var pos = null, startX = 0, startPos = 0;
      this.fit = function () {
        var w = self.offsetWidth;
        if (wrap) wrap.style.width = w + 'px';
        self.style.setProperty('--cmp-w', w + 'px');
      };
      var place = function (x) {
        var w = self.offsetWidth;
        x = Math.max(50, Math.min(w - 50, x));
        pos = x;
        drag.style.width = x + 'px';
        btn.style.transform = 'translate(' + (x - w / 2 - btn.offsetWidth / 2) + 'px, -50%)';
      };
      this.fit();
      window.addEventListener('resize', this.fit);
      btn.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        startX = e.clientX; startPos = pos === null ? self.offsetWidth / 2 : pos;
        btn.setPointerCapture(e.pointerId);
        var move = function (ev) { place(startPos + ev.clientX - startX); };
        var up = function () { btn.removeEventListener('pointermove', move); btn.removeEventListener('pointerup', up); btn.removeEventListener('pointercancel', up); };
        btn.addEventListener('pointermove', move); btn.addEventListener('pointerup', up); btn.addEventListener('pointercancel', up);
      });
    }
    disconnectedCallback() { if (this.fit) window.removeEventListener('resize', this.fit); }
  }
  customElements.define('eight-compare', EightCompare);

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-video-popup]');
    if (!b) return;
    e.preventDefault();
    var box = document.createElement('div');
    box.className = 'eight-lightbox eight-lightbox--video';
    box.innerHTML = '<button type="button" class="eight-lightbox__close" aria-label="Close">&times;</button><div class="video-wrapper" style="width:min(90vw,1100px)"><iframe src="https://www.youtube.com/embed/' +
      encodeURIComponent(b.getAttribute('data-video-popup')) + '?autoplay=1&rel=0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>';
    box.addEventListener('click', function (ev) { if (ev.target === box || ev.target.closest('.eight-lightbox__close')) box.remove(); });
    document.body.appendChild(box);
  });

  /* Pickup availability under the buy buttons; refreshed when the variant changes */
  function loadPickup(el, variantId) {
    var url = window.location.pathname.split('?')[0] + '?variant=' + variantId + '&section_id=store-availability';
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var c = doc.querySelector('.store-availability');
      el.innerHTML = c ? c.outerHTML : '';
    }).catch(function () {});
  }
  document.addEventListener('DOMContentLoaded', function () {
    eight.qa('[data-store-availability]').forEach(function (el) { loadPickup(el, el.getAttribute('data-variant')); });
  });
  document.addEventListener('variant:change', function (e) {
    if (!e.detail || !e.detail.variant || !e.detail.product) return;
    eight.qa('[data-store-availability]').forEach(function (el) { loadPickup(el, e.detail.variant.id); });
  });
})();
